import {
  _IDLE,
  _BUSY,
  _ALERT_TYPES,
  _API_CALLED,
  _DOWNLINE_SEARCH,
  _DOWNLINE_QUERY,
  _REFERRAL_SEARCH,
  _REFERRAL_QUERY,
  _SET_Y,
  _SET_PAGESIZE,
  _SET_ACTIVE_TAB,
  _IS_KEEPED_LOGIN,
  _GAME_SEARCH,
  _GAME_QUERY,
  _SET_BOTTOM_TAB_INDEX,
  _BIND_SETTING,
  _BIND_MEMBER,
  _BIND_MEMBER_WALLET,
  _BIND_MEMBER_WALLET_BALANCE,
  _BIND_GAMES,
  _BIND_GAMES_RECOMMENDED,
  _BIND_GAMES_FEATURED,
  _SET_PAYMENT_LIST,
  _SET_WALLET_INFO,
  _SET_OPEN_MENU,
  _SET_REPORT_OVERVIEW,
  _SET_DOWNLINE,
  _SET_BANNERS,
  _SET_DEPOSIT_MODAL,
  _SET_DEPOSIT_TAB,
  _SET_LOGIN_MODAL,
  _SET_REGISTER_MODAL,
  _SET_PROVIDER,
  _SET_LATEST_BETS,
  _SET_GAME_LOBBY_MODAL,
  _SET_RESET_PASSWORD,
  _SET_DOWNLINE_MODAL,
  _SET_SHARE_REFERRAL_MODAL,
  _BUSY_LOADING,
  _SET_PROFILE_MODAL,
  _SET_SPIN_WHEEL_LIST_MODAL,
  _SET_SPIN_WHEEL_REPORT_MODAL,
  _SET_SEO_CONTENT,
  _SET_REPORT_OVERVIEW_MODAL,
  _SET_GAME_IFRAME_MODAL,
  _SET_COMPLETE_INFO_MODAL,
  _SET_DAILY_CHECKIN_MODAL,
  _SET_DAILY_CHECKIN_EXIST,
  _SET_REFERRAL_BONUS_MODAL,
  _SET_MUSIC_PLAYER_MODAL,
  _SET_SPIN_WHEEL_LOADED,
  _BIND_HOT_GAMES,
  _BIND_HOT_PROVIDERS,
  _SET_LANGUAGE_MODAL,
  _SET_DAILY_CHECK_IN_DETAILS,
  _SET_REWARD_TYPE,
  _SET_GAME_PROVIDER,
  _SET_REGISTER_SUCCESS_MODAL,
  _SET_SHOW_ANNOUNCEMENT_MODAL,
  _FETCH_BANNERS_REQUEST,
  _FETCH_BANNERS_SUCCESS,
  _FETCH_BANNERS_FAILURE,
  _SYNC_MODAL_ORCHESTRATOR,
} from "./AppAction";
import { stringIsNullOrEmpty } from "../util/Util";
import i18n from "../localization/i18n";
import { mergeVipProgressIntoMember } from "./mergeVipProgressIntoMember";

const NEW_GAME_MONTHS = 3;

const isWithinNewGameWindow = (productGameCreatedTime) => {
  if (!productGameCreatedTime) return false;
  const created = new Date(productGameCreatedTime);
  if (Number.isNaN(created.getTime())) return false;
  const cutoff = new Date();
  cutoff.setUTCMonth(cutoff.getUTCMonth() - NEW_GAME_MONTHS);
  return created >= cutoff;
};

/** GetSetting/WebCache may bake stale isNewGame; derive from ProductGameCreatedTime + admin bit. */
const normalizeHotGames = (hotGames) =>
  Array.isArray(hotGames)
    ? hotGames.map((game) => {
        const productGameCreatedTime =
          game.productGameCreatedTime ?? game.ProductGameCreatedTime;
        const adminIsNew = !!(game.isNewGame || game.IsNewGame);
        return {
          ...game,
          id: game.gameId ?? game.id,
          productGameCreatedTime,
          isNewGame: adminIsNew || isWithinNewGameWindow(productGameCreatedTime),
        };
      })
    : [];

const _INITIAL_STATE = {
  brandName: "",
  isBusy: false,
  isBusyLoading: false,
  isKeepedLogin: false,
  message: i18n.t("LOADING"),
  alert: {},
  iconEnabled: true,
  apiCalledResponse: {},
  savedText: "",
  savedReferralText: "",
  gameSavedText: "",
  savedQuery: "", // KT: DEFAULT REMOVED
  savedReferralQuery: "", // KT: DEFAULT REMOVED
  gameQuery: "", // KT: DEFAULT REMOVED
  y: 0,
  pageSize: 10,
  activeTab: 0,
  bottomTabIndex: 0,
  member: {},
  games: [],
  gamesRecommended:{
    slotGamesCount:0,
    slotGames:[],
    casinoGamesCount:0,
		casinoGames:[]
  },
  gamesFeatured:{
    slotGamesCount:0,
    slotGames:[],
  },
  gameProviderId:0,
  hotGames:[],
  payments: [],
  walletBalance: 0,
  walletInfo: [],
  reportOverview: {
    displayData: [],
    newDisplayData: [],
    totalTransferToWallet: 0,
    totalTransferToWalletLM: 0,
    totalTransferToMember: 0,
    totalTransferToMemberLM: 0,
    totalBetAmount: 0,
    totalBetAmountLM: 0,
    totalCommission: 0,
    totalCommissionLM: 0,
    totalVipCommission: 0,
    totalBonus: 0,
  },
  downline: {
    memberData: null,
    recentData: null,
  },
  banners: [],
  bannersStatus: "idle", // idle, loading, succeeded, failed
  bannersError: null,
  themeName: "template1",
  openMenu: true,
  depositModal:false,
  depositTab:1,
  loginModal:false,
  gameLobbyModal:false,
  registerModal:false,
  registerSuccessModal:false,
  showAnnouncementModal:false,
  modalActive: null,
  modalQueue: [],
  provider:[],
  channels:[],
  latestBets:[],
  walletsDetails:{
    currentWalletBalance : 0,
    bonusWalletBalance : 0,
    isPromoCleared :false,
    isBonusWalletRestored : false,
    isValidForPromotion : false,
    isActivedPromoExist: false,
    promoMaxWithdrawal: false,
    minCoinTarget: 0,
    promotionName:"",
    promoRolloverBalance:0,
    promoRolloverTarget:0,
    isFreeGGRPromo: false,
    forceWithdraw: false,
    promoExpiresAt: null,
  },
  companyIcons:[],
  bannerAPK:{},
  homepageBanner:[],
  isResetPassword:false,
  downlineModal:false,
  reportOverviewModal:false,
  shareReferralModal:false,
  companyCurrency:"$",
  depositPresetAmt:"30,50,100,200,500,1000",
  htmlStyle: false,
  chatSphere: [],
  quickRegister: [],
  languages: [],
  profileModal: false,
  seoContent:{
    pageName:"",
    seoTitle:"",
    seoDescription:"",
    seoKeywords:""
  },
  companyCurrencySymbol: "$",
  gameIframeModal: false,
  dialingCodes: [],
  promotionLayout: "1",
  promotionShowCategoryTitle: true,
  completeInfoModal:false,
  showPromoThumbnailClaimButton: false,
  isPromoBannerTextVisible: true,
  dailyCheckinModal:false,
  dailyCheckInExist:false,
  referralBonusModal: false,
  isReferralBonusActive: false,
  isReferralRegistrationBonusActive: false,
  dashboardComponent: [],
  isNormalDepositEnable: false,
  isNormalWithdrawalEnable: false,
  isCryptoWithdrawalEnabled: false,
  musicPlayerModal: false,
  companyTimeZone:"",
  languageModal:false,
  rolloverDetails:[],
  dailyCheckInDetails:{},
  spinWheelListModal:false,
  rewardType:"",
  requireBankAccountKYC: false,
  isRegistrationSuccessCountdownEnabled: false,
	maxWithdrawalBankAccounts: 0,
  requireMemberEmailOnWithdrawal: false,
  showDepositBankBranchCode: false,
  settingVersion:"",
  //isHotProviderEnabled: false,
  hotProviders: [],
  productHotNewGames: { hotGames: [], newGames: [] },
  playerCounterSetting: [],
  playerCounters: [],
  leaderboard: [],
  /** When non-null, theme schema is a preview from Backoffice (?preview=guid). */
  themePreviewGuid: null,
  //KT: Counter check later on missing vars
 }

var _busyCount = 0;

export default (state = _INITIAL_STATE, action) => {
  switch (action.type) {
    case _BUSY:
      _busyCount++;
      return {
        ...state,
        isBusy: true,
        message: stringIsNullOrEmpty(action.message)
          ? i18n.t("LOADING")
          : action.message,
        iconEnabled:
          action.iconEnabled == null
            ? _INITIAL_STATE.iconEnabled
            : action.iconEnabled,
      };
      break;
    case _IDLE:
      _busyCount = Math.max(--_busyCount, 0);
      return {
        ...state,
        isBusy: _busyCount != 0,
      };
      break;
    case _ALERT_TYPES.SET_ALERT:
      return {
        ...state,
        alert: Object.keys(state.alert) == 0 ? action.alert : state.alert,
      };
      break;
    case _ALERT_TYPES.NONE:
      return {
        ...state,
        alert: {},
      };
      break;
    case _API_CALLED:
      return {
        ...state,
        apiCalledResponse: action.data,
      };
      break;
    case _DOWNLINE_SEARCH:
      return {
        ...state,
        savedText: action.data,
      };
      break;
    case _DOWNLINE_QUERY:
      return {
        ...state,
        savedQuery: action.data,
      };
      break;
    case _REFERRAL_SEARCH:
      return {
        ...state,
        savedReferralText: action.data,
      };
      break;
    case _REFERRAL_QUERY:
      return {
        ...state,
        savedReferralQuery: action.data,
      };
      break;
    case _GAME_SEARCH:
      return {
        ...state,
        gameSavedText: action.data,
      };
      break;
    case _GAME_QUERY:
      return {
        ...state,
        gameQuery: action.data,
      };
      break;
    case _SET_Y:
      return {
        ...state,
        y: action.y,
      };
    case _SET_PAGESIZE:
      return {
        ...state,
        pageSize: action.data,
      };
      break;
    case _SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.data,
      };
      break;
    case _SET_BOTTOM_TAB_INDEX:
      return {
        ...state,
        bottomTabIndex: action.bottomTabIndex,
      };
      break;
    case _BIND_MEMBER:
      return {
        ...state,
        member: action.member,
        walletBalance: action.walletBalance,
        walletsDetails: action.walletsDetails,
        rolloverDetails: action.rolloverDetails
      };
      break;
    case _BIND_MEMBER_WALLET_BALANCE:
      return {
        ...state,
        member: mergeVipProgressIntoMember(state.member, action.vipProgress),
        walletBalance: action.walletBalance,
        walletsDetails: action.walletsDetails,
        rolloverDetails: action.rolloverDetails,
      };
    case _BIND_MEMBER_WALLET:
      return {
        ...state,
        walletsDetails: action.walletsDetails,
      };
    case _BIND_GAMES:
      return {
        ...state,
        games: action.games,
      };
      break;
    case _BIND_GAMES_RECOMMENDED:
      return {
        ...state,
        gamesRecommended: {
          slotGamesCount: action.slotGamesCount,
          slotGames: action.slotGames,
          casinoGamesCount: action.casinoGamesCount,
	      casinoGames: action.casinoGames
        }
      };
      break;
    case _BIND_GAMES_FEATURED:
      return {
        ...state,
        gamesFeatured: {
          slotGamesCount: action.slotGamesCount,
          slotGames: action.slotGames
        }
      };
      break;
    case _SET_PAYMENT_LIST:
      return {
        ...state,
        payments: action.payments,
      };
      break;
    case _SET_OPEN_MENU:
      return {
        ...state,
        openMenu: action.data,
      };
      break;
    case _SET_WALLET_INFO:
      return {
        ...state,
        walletInfo: action.data,
      };
      break;

    case _SET_REPORT_OVERVIEW:
      state.reportOverview.displayData = action.displayData;
      state.reportOverview.newDisplayData = action.newDisplayData;
      state.reportOverview.totalTransferToWallet = action.totalTransferToWallet;
      state.reportOverview.totalTransferToWalletLM = action.totalTransferToWalletLM;
      state.reportOverview.totalTransferToMember = action.totalTransferToMember;
      state.reportOverview.totalTransferToMemberLM = action.totalTransferToMemberLM;
      state.reportOverview.totalBetAmount = action.totalBetAmount;
      state.reportOverview.totalBetAmountLM = action.totalBetAmountLM;
      state.reportOverview.totalCommission = action.totalCommission;
      state.reportOverview.totalCommissionLM = action.totalCommissionLM;
      state.reportOverview.totalVipCommission = action.totalVipCommission;
      state.reportOverview.totalBonus = action.totalBonus;

      return {
        ...state,
      };
      break;
    case _SET_DOWNLINE:
      state.downline.memberData = action.memberData;
      state.downline.recentData = action.recentData;
      return {
        ...state,
      };
      break;
    case _SET_BANNERS:
      return {
        ...state,
        banners: action.banners,
        bannersStatus: "succeeded",
      };
      break;
    case _FETCH_BANNERS_REQUEST:
      return {
        ...state,
        bannersStatus: "loading",
      };
      break;
    case _FETCH_BANNERS_SUCCESS:
      return {
        ...state,
        banners: action.banners,
        bannersStatus: "succeeded",
      };
      break;
    case _FETCH_BANNERS_FAILURE:
      return {
        ...state,
        bannersStatus: "failed",
        bannersError: action.error,
      };
      break;
    case _SET_DEPOSIT_MODAL:
      return {
        ...state,
        depositModal: action.depositModal,
        depositTab: action.depositTab
      };
      break;
    case _SET_DOWNLINE_MODAL:
      return {
        ...state,
        downlineModal: action.downlineModal,
      };
      break;
    case _SET_SHARE_REFERRAL_MODAL:
      return {
        ...state,
        shareReferralModal: action.shareReferralModal,
      };
      break;
    case _SET_DEPOSIT_TAB:
      return {
        ...state,
        depositTab: action.depositTab
      };
      break;
    case _SET_LOGIN_MODAL:
      return {
        ...state,
        loginModal: action.loginModal
      };
      break;
    case _SET_GAME_LOBBY_MODAL:
      return {
        ...state,
        gameLobbyModal: action.gameLobbyModal
      };
      break;
    case _SET_REGISTER_MODAL:
      return {
        ...state,
        registerModal: action.registerModal
      };
      break;
    case _SET_PROVIDER:
      return {
        ...state,
        provider: action.provider
      };
      break;
    case _SET_LATEST_BETS:
      return {
        ...state,
        latestBets: action.latestBets
      };
      break;
    case _SET_RESET_PASSWORD:
      return {
        ...state,
        isResetPassword: action.isResetPassword
      };
      break;

    case _BUSY_LOADING:
      return {
        ...state,
        isBusyLoading: action.isBusyLoading,
      };
      break;
    case _SET_PROFILE_MODAL:
      return {
        ...state,
        profileModal: action.profileModal
      };
      break;
    case  _SET_SPIN_WHEEL_LIST_MODAL:
      return{
        ...state,
        spinWheelListModal: action.spinWheelListModal
      };
      case  _SET_SPIN_WHEEL_REPORT_MODAL:
        return{
          ...state,
          spinWheelReportModal: action.spinWheelReportModal
        };
    case _SET_GAME_IFRAME_MODAL:
      return {
        ...state,
        gameIframeModal: action.gameIframeModal,
      };
      break;
    case _SET_SEO_CONTENT:
      state.seoContent.pageName = action.pageName;
      state.seoContent.seoTitle = action.seoTitle;
      state.seoContent.seoDescription = action.seoDescription;
      state.seoContent.seoKeywords = action.seoKeywords;

      return {
        ...state,
      };
      break;
    case _BIND_SETTING:
      return {
        ...state,
        depositPresetAmt: action.depositPresetAmt != null ? action.depositPresetAmt : "30,50,100,200,500,1000", // MULTITAB THINGY
        companyCurrency: action.companyCurrency, // Account/GetCompanyDetails
        companyIcons: action.companyIcons,
        channels: action.channels,
        htmlStyle: action.htmlStyle,
        chatSphere: action.chatSphere,
        quickRegister: action.quickRegister,
        languages: action.languages,
        brandName: action.brandName,
        membershipEnabled: action.membershipEnabled,
        currencySymbol: action.currencySymbol,
        dialingCodes : action.dialingCodes,
        settingApiComplete: action.settingApiComplete,
        promotionLayout: action.promotionLayout,
        promotionShowCategoryTitle: action.promotionShowCategoryTitle,
        showPromoThumbnailClaimButton: action.showPromoThumbnailClaimButton,
        isPromoBannerTextVisible: action.isPromoBannerTextVisible,
        isReferralBonusActive: action.isReferralBonusActive,
        isReferralRegistrationBonusActive: action.isReferralRegistrationBonusActive,
        otpEnabled: action.otpEnabled,
        eWalletOTPEnabled: action.eWalletOTPEnabled,
        captchaEnabled: action.captchaEnabled,
        priorityModalTypeId: action.priorityModalTypeId,
        dashboardComponent: action.dashboardComponent,
        isNormalDepositEnable: action.isNormalDepositEnable,
        isNormalWithdrawalEnable: action.isNormalWithdrawalEnable,
        isCryptoWithdrawalEnabled: action.isCryptoWithdrawalEnabled,
        musicPlayerEnabled: action.musicPlayerEnabled,
        musicTrackList: action.musicTrackList,
        isEWalletActive: action.isEWalletActive,
        isBankTransferActive: action.isBankTransferActive,
        isReferralCommissionManual: action.isReferralCommissionManual,
        isRebateManual: action.isRebateManual,
        availableProductCategories: action.availableProductCategories || [],
        isGameLobbyRequired: action.isGameLobbyRequired,
        companyTimeZone: action.companyTimeZone,
        bannerAPK:action.bannerAPK,
        homepageBanner:action.homepageBanner,
        //floatingChat:action.floatingChat,
        isLoginAttemptBlockingEnabled: action.isLoginAttemptBlockingEnabled,
        isHotGameEnabled: action.isHotGameEnabled,
        hotGames: normalizeHotGames(action.hotGames),
        affiliateLink: action.affiliateLink,
        isCasinoLobbyEnabled: action.isCasinoLobbyEnabled,
        isEZUsernameEnabled: action.isEZUsernameEnabled,
        infoCenterEnabled: action.infoCenterEnabled,
        forceMemberFullname: action.forceMemberFullname,
        affiliateEnabled: action.affiliateEnabled,
        affiliateNewTabEnabled: action.affiliateNewTabEnabled,
        isMultiWithdrawalBank: action.isMultiWithdrawalBank,
		maxWithdrawalBankAccounts: action.maxWithdrawalBankAccounts,
        depositFlow: action.depositFlow,
        downlineContact: action.downlineContact,
        isRTPRequired: action.isRTPRequired,
        oneWallet: action.oneWallet,
        availableProviders: action.availableProviders,
        floatingChat: action.floatingChat,
        spinWheelSetting: action.spinWheelSetting,
        dashboardResult: action.dashboardResult,
        infoCenterResult: action.infoCenterResult,
        dailyCheckInStatus: action.dailyCheckInStatus,
        marqueeResult: action.marqueeResult,
        rewardAdvancedSetting: action.rewardAdvancedSetting,
        requireBankAccountKYC: action.requireBankAccountKYC,
        isRegistrationSuccessCountdownEnabled: action.isRegistrationSuccessCountdownEnabled,
        inactiveDownlineAmount: action.inactiveDownlineAmount,
        settingVersion: action.settingVersion,
        isHotProviderEnabled: action.isHotProviderEnabled,
        hotProviders: action.hotProviders ?? state.hotProviders,
        productHotNewGames: action.productHotNewGames ?? state.productHotNewGames,
        playerCounterSetting: action.playerCounterSetting ?? state.playerCounterSetting,
        playerCounters: action.playerCounters ?? state.playerCounters,
        requireMemberEmailOnWithdrawal: action.requireMemberEmailOnWithdrawal,
        showDepositBankBranchCode: action.showDepositBankBranchCode,
        leaderboard: action.leaderboard !== undefined ? action.leaderboard : state.leaderboard,
      };
    case _SET_REPORT_OVERVIEW_MODAL:
      return {
        ...state,
        reportOverviewModal: action.reportOverviewModal,
      };
      break;
    case _SET_COMPLETE_INFO_MODAL:
      return {
        ...state,
        completeInfoModal: action.completeInfoModal
      };
      break;
    case _SET_REGISTER_SUCCESS_MODAL:
      return {
        ...state,
        registerSuccessModal: action.registerSuccessModal
      };
      break;
    case _SET_SHOW_ANNOUNCEMENT_MODAL:
      return {
        ...state,
        showAnnouncementModal: action.showAnnouncementModal
      };
    break;
    case _SYNC_MODAL_ORCHESTRATOR:
      return {
        ...state,
        ...(action.flags || {}),
        modalActive: action.modalActive ?? null,
        modalQueue: Array.isArray(action.modalQueue) ? action.modalQueue : [],
        ...(action.depositTab != null ? { depositTab: action.depositTab } : {}),
      };
    case _SET_DAILY_CHECKIN_MODAL:
      return {
        ...state,
        dailyCheckinModal: action.dailyCheckinModal
      };
      break;
    case _SET_DAILY_CHECKIN_EXIST:
      return {
        ...state,
        dailyCheckInExist: action.dailyCheckInExist
      };
      break;
    case _SET_REFERRAL_BONUS_MODAL:
      return {
        ...state,
        referralBonusModal: action.referralBonusModal
      };
      break;
    case _SET_MUSIC_PLAYER_MODAL:
      return {
        ...state,
        musicPlayerModal: action.musicPlayerModal
      };
      break;
    case _SET_SPIN_WHEEL_LOADED:
      return {
        ...state,
        spinWheelLoaded: action.spinWheelLoaded
      };
      break;
    case _IS_KEEPED_LOGIN:
      return {
        ...state,
        isKeepedLogin: action.data,
      };
      break;
    case _BIND_HOT_GAMES:
      return {
        ...state,
        hotGames: normalizeHotGames(action.hotGames),
      };
      break;
    case _BIND_HOT_PROVIDERS:
      return {
        ...state,
        hotProviders: action.hotProviders,
      };
      break;
    case _SET_LANGUAGE_MODAL:
      return {
        ...state,
        languageModal: action.languageModal
      };
      break;
    case _SET_DAILY_CHECK_IN_DETAILS:
      return {
        ...state,
        dailyCheckInDetails: action.dailyCheckInDetails
      };
      break;
    case _SET_REWARD_TYPE:
      return{
        ...state,
        rewardType: action.rewardType
      };
    case _SET_GAME_PROVIDER:
      return{
        ...state,
        gameProviderId: action.gameProviderId
      };
    default:
      return state;
      break;
  }
};
